module.exports = __webpack_public_path__ + "media/common/icons/linkio_logo-c6d61fa34e027c30b6cbd2b3a8b1b4f0.svg";